import React, { useMemo, useState, useEffect } from "react";
import Cookies from "universal-cookie";
import moment from "moment";
// import { useSearchParams } from "react-router-dom";

import { timers } from "jquery";
import { URLS } from "./components/urls";
import { LeftArrowIcon, RightArrowIcon } from "./components/icons";
import { isEmpty, toNumber } from "lodash";
import LogoImage from "./LogoImage";
import { toast } from "react-toastify";

function isEnterKey(e) {
  return e.keyCode === 13;
}

function deepClone(data) {
  return JSON.parse(JSON.stringify(data));
}

export { isEnterKey, deepClone };

export function Logo(props) {
  return (
    <svg
      {...props}
      width="80"
      height="40"
      viewBox="0 0 80 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="80" height="40" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_833_4536"
            transform="scale(0.00714286 0.0142857)"
          />
        </pattern>
        <image
          id="image0_833_4536"
          width="140"
          height="70"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
}

export function HamburgerIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 10H13.125"
        stroke="#0F172A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.75 5H16.25"
        stroke="#0F172A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.75 15H11.875"
        stroke="#0F172A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function useIsInViewport(ref) {
  const options = {
    threshold: 1,
    rootMargin: "0px",
    root: null,
  };

  const [isIntersecting, setIsIntersecting] = useState(false);

  const observer = useMemo(
    () =>
      new IntersectionObserver(
        ([entry]) => setIsIntersecting(entry.isIntersecting),
        options
      ),
    []
  );

  useEffect(() => {
    ref && observer.observe(ref);

    return () => {
      observer.disconnect();
    };
  }, [ref, observer]);

  return isIntersecting;
}

export function resolveApprovalBadgeBg(status) {
  return status?.toLowerCase() === "pending"
    ? "warning"
    : status?.toLowerCase() === "disapproved"
    ? "danger"
    : "success";
}

export const allMonths = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const fetchActionsUtil = async (url, method, token, payload) => {
  let response = await fetch(url, {
    method: method,
    credentials: "include",
    body: JSON.stringify(payload),
    headers: {
      Accept: "Application/json",
      "Content-Type": "Application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  if (!response.ok) {
    response = await response.json();
    console.log(response);
    return response;
    // throw new Error(response.message);
  }
  const res = await response.json();
  // console.log(res);
  // const { data, message } = res;
  return res;
};

const cookie = new Cookies();

export const branch_id = cookie.get("branch_id");

export const exportedUserId = cookie.get("userId");

// Custom hook to get a cookie value
export const useCookie = (name) => {
  const getCookieValue = () => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
      return parts.pop().split(";").shift();
    }

    return null;
  };

  const [cookieValue, setCookieValue] = useState(getCookieValue());

  // Use effect to update cookie value if it changes
  useEffect(() => {
    const handleCookieChange = () => {
      setCookieValue(getCookieValue());
    };

    // Listen to the document's cookie change events
    document.addEventListener("cookiechange", handleCookieChange);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("cookiechange", handleCookieChange);
    };
  }, [name]);

  return cookieValue;
};

export const checkDateYear = (date) => {
  return moment(
    moment(date, "DD/MM/YYYY").add(1, "year").format("DD/MM/YYYY"),
    "DD/MM/YYYY"
  ).isSame(
    moment(moment(new Date()).format("DD/MM/YYYY"), "DD/MM/YYYY"),
    "month"
  );
};

export const checkDates = ({ date, day, status }) => {
  return moment(
    moment(date, "DD/MM/YYYY").add(day, status).format("DD/MM/YYYY"),
    "DD/MM/YYYY"
  ).isBefore(
    moment(moment(new Date()).format("DD/MM/YYYY"), "DD/MM/YYYY"),
    status
  );
};

export const checkAfterDate = ({ date, payrollDate }) => {
  return (
    new Date(moment(date, "DD/MM/YYYY").format("YYYY-MM-DD")) >
    new Date(`${payrollDate?.payrollYear}-${payrollDate?.payrollMonth}-1`)
  );
};

export const checkStartDate = ({ date, startDate }) => {
  return moment(date, "DD/MM/YYYY").isBefore(moment(startDate, "DD/MM/YYYY"));
};

export const checkDays = ({ startDate, endDate, payrollDate }) => {
  return (
    moment(
      moment(startDate, "MM/yyyy").format("MM/yyyy"),
      "MM/yyyy"
    ).isSameOrBefore(
      moment(
        moment(
          payrollDate
            ? new Date(
                `${payrollDate?.payrollYear}-${payrollDate?.payrollMonth}-1`
              )
            : new Date()
        ).format("MM/yyyy"),
        "MM/yyyy"
      )
    ) &&
    moment(
      moment(endDate, "MM/yyyy").format("MM/yyyy"),
      "MM/yyyy"
    ).isSameOrAfter(
      moment(
        moment(
          payrollDate
            ? new Date(
                `${payrollDate?.payrollYear}-${payrollDate?.payrollMonth}-1`
              )
            : new Date()
        ).format("MM/yyyy"),
        "MM/yyyy"
      )
    )
  );
};

export const checkSalaryRange = ({ salary, min, max }) => {
  let data = false;

  if (min && min) {
    if (
      parseFloat(salary) >= parseFloat(min) &&
      parseFloat(salary) <= parseFloat(max)
    ) {
      data = true;
    }
  }

  return data;
};

export const employeePercentageSalary = ({
  bene,
  employee,
  settings,
  key,
  totalGross,
}) => {
  let sum = 0;

  if (
    bene["DeductType"] === "Employees" &&
    bene["selectedDeducts"]?.includes(employee["userId"])
  ) {
    sum +=
      // settings?.payType !== "Net Pay" && useExcel === "Use Timesheet"
      settings?.payType !== "Net Pay"
        ? (parseFloat(employee?.totalDaysWorked) /
            parseFloat(settings?.workingDays)) *
          parseFloat(employee[key])
        : employee[key];

    // sum += employee[key];
  } else if (
    bene["DeductType"] === "Job Grade" &&
    bene["selectedDeducts"]?.includes(employee["grade"]?._id)
  ) {
    sum +=
      // settings?.payType !== "Net Pay" && useExcel === "Use Timesheet"
      settings?.payType !== "Net Pay"
        ? (parseFloat(employee?.totalDaysWorked) /
            parseFloat(settings?.workingDays)) *
          parseFloat(employee[key])
        : employee[key];
  } else if (
    bene["DeductType"] === "Contract" &&
    bene["selectedDeducts"]?.includes(employee["contractType"])
  ) {
    // sum += employee[key];
    sum +=
      // settings?.payType !== "Net Pay" && useExcel === "Use Timesheet"
      settings?.payType !== "Net Pay"
        ? (parseFloat(employee?.totalDaysWorked) /
            parseFloat(settings?.workingDays)) *
          parseFloat(employee[key])
        : employee[key];
  } else if (bene["DeductType"] === "All") {
    // sum += employee[key];
    sum +=
      // settings?.payType !== "Net Pay" && useExcel === "Use Timesheet"
      settings?.payType !== "Net Pay"
        ? (parseFloat(employee?.totalDaysWorked) /
            parseFloat(settings?.workingDays)) *
          parseFloat(employee[key])
        : employee[key];
  } else if (
    bene["DeductType"] === "Permanent" &&
    employee["usedcontract"] === undefined
  ) {
    sum +=
      // settings?.payType !== "Net Pay" && useExcel === "Use Timesheet"
      settings?.payType !== "Net Pay"
        ? (parseFloat(employee?.totalDaysWorked) /
            parseFloat(settings?.workingDays)) *
          parseFloat(employee[key])
        : employee[key];
  } else if (
    bene["DeductType"] === "Range" &&
    checkSalaryRange({
      salary: totalGross,
      max: bene?.maxRange,
      min: bene?.minRange,
    })
  ) {
    sum +=
      // settings?.payType !== "Net Pay" && useExcel === "Use Timesheet"
      settings?.payType !== "Net Pay"
        ? (parseFloat(employee?.totalDaysWorked) /
            parseFloat(settings?.workingDays)) *
          parseFloat(employee[key])
        : employee[key];
  }

  return sum;
};

export const employeeStaticSalary = ({
  bene,
  employee,
  totalGross,
  settings,
}) => {
  let total = 0;

  if (
    bene["DeductType"] === "Employees" &&
    bene["selectedDeducts"]?.includes(employee["userId"])
  ) {
    total = bene.percentage;
  } else if (
    bene["DeductType"] === "Job Grade" &&
    bene["selectedDeducts"]?.includes(employee["grade"]?._id)
  ) {
    total = bene.percentage;
  } else if (
    bene["DeductType"] === "Contract" &&
    bene["selectedDeducts"]?.includes(employee["contractType"])
  ) {
    total = bene.percentage;
  } else if (bene["DeductType"] === "All") {
    total = bene.percentage;
  } else if (
    bene["DeductType"] === "Permanent" &&
    employee["usedcontract"] === undefined
  ) {
    total = bene.percentage;
  } else if (
    bene["DeductType"] === "Range" &&
    checkSalaryRange({
      salary: totalGross,
      max: bene?.maxRange,
      min: bene?.minRange,
    })
  ) {
    total = bene.percentage;
  }

  return total;
};

export const employeeTaxLaw = ({ bene, employee, totalGross }) => {
  let total = false;

  if (
    bene["DeductType"] === "Employees" &&
    bene["selectedDeducts"]?.includes(employee["userId"])
  ) {
    total = true;
  } else if (
    bene["DeductType"] === "Job Grade" &&
    bene["selectedDeducts"]?.includes(employee["grade"]?._id)
  ) {
    total = true;
  } else if (
    bene["DeductType"] === "Contract" &&
    bene["selectedDeducts"]?.includes(employee["contractType"])
  ) {
    total = true;
  } else if (bene["DeductType"] === "All") {
    total = true;
  } else if (
    bene["DeductType"] === "Permanent" &&
    employee["usedcontract"] === undefined
  ) {
    total = true;
  } else if (
    bene["DeductType"] === "Range" &&
    checkSalaryRange({
      salary: totalGross,
      max: bene?.maxRange,
      min: bene?.minRange,
    })
  ) {
    total = true;
  }

  return total;
};

export const calculateMultiPayRollSettings = ({
  data,
  employee,
  pre = [],
  settings,
  useExcel,
  overSettings = [],
  leaves = [],
  totalGross,
  payrollDate,
  leaveSettings,
}) => {
  let totalSum = 0;

  const otherData = data?.map((bene) => {
    let sum = 0;
    let total = 0;
    let maturity = true;
    let duration = true;
    let taxLaw = false;

    bene = {
      ...bene,
      ...converArrayToObject(bene["customSettings"], "status", "name"),
    };

    // Check the maturity period of the allowance
    if (bene["paymentPeriod"] === "CustomPeriod") {
      const getTime = bene["maturityPeriod"]?.split(" ");
      maturity = getTime
        ? checkDates({
            date: employee["startDate"],
            day: getTime[0],
            status: getTime[1],
          })
        : false;
    }

    // Check for Duration Period of the allowance
    if (bene["durationType"] === "CustomDuration") {
      duration = checkDays({
        startDate: bene["dateRange"]["startDate"],
        endDate: bene["dateRange"]["endDate"],
        payrollDate,
      });
    }

    if (maturity && duration) {
      // find hours in allowance
      const hours = overSettings.find(
        (el) =>
          el["employeeId"] === employee["userId"] &&
          el["allowanceId"] === bene["_id"] &&
          el["status"] === "Approved"
      )?.hours;

      const userLeave = leaves.filter(
        (el) =>
          el["employee"]["id"]["_id"] === employee["emps_id"] &&
          bene["leaveId"] === el["leaveId"]
      );

      for (let key in bene) {
        // When its Percentage
        if (
          key !== "enabled" &&
          bene["paymentType"] === "Percentage" &&
          bene[key] === true
        ) {
          // Checking for allowance
          if (bene["earned"] === true) {
            const account = key !== "earned" ? employee[key] : 0;
            if (hours !== undefined) {
              sum +=
                // settings?.payType !== "Net Pay" && useExcel === "Use Timesheet"
                settings?.payType !== "Net Pay"
                  ? (parseFloat(employee?.totalDaysWorked) /
                      parseFloat(settings?.workingDays)) *
                    parseFloat(account)
                  : account;
            } else if (userLeave?.length > 0) {
              let num = 0;

              if (leaveSettings?.applyAllowanceImmediately) {
                userLeave.forEach((el) => {
                  if (key !== "earned") {
                    if (
                      moment(el.to, "YYYY-MM-DD").isAfter(moment(), "month") ||
                      moment(el.to, "YYYY-MM-DD").isSame(moment(), "month")
                    ) {
                      num += employeePercentageSalary({
                        bene,
                        employee,
                        settings,
                        key,
                        totalGross,
                      });
                    }
                  }
                });

                sum += num;
              } else {
                userLeave.forEach((el) => {
                  if (key !== "earned") {
                    if (
                      (moment(el.from, "YYYY-MM-DD").isBefore(
                        moment(),
                        "month"
                      ) ||
                        moment(el.from, "YYYY-MM-DD").isSame(
                          moment(),
                          "month"
                        )) &&
                      (moment(el.to, "YYYY-MM-DD").isAfter(moment(), "month") ||
                        moment(el.to, "YYYY-MM-DD").isSame(moment(), "month"))
                    ) {
                      num += employeePercentageSalary({
                        bene,
                        employee,
                        settings,
                        key,
                        totalGross,
                      });
                    }
                  }
                });
                sum += num;
              }
            }
          } else {
            sum += employeePercentageSalary({
              bene,
              employee,
              settings,
              key,
              totalGross,
            });
          }
        }

        // When is Static
        if (bene["paymentType"] === "Static" && bene["enabled"] === true) {
          // Checking for allowance
          if (bene["earned"] === true) {
            // console.log(hours, bene.percentage);
            if (hours !== undefined) {
              total = bene.percentage;
            } else if (userLeave?.length > 0) {
              let num = 0;

              if (leaveSettings?.applyAllowanceImmediately) {
                userLeave.forEach((el) => {
                  if (
                    moment(el.to, "YYYY-MM-DD").isAfter(moment(), "month") ||
                    moment(el.to, "YYYY-MM-DD").isSame(moment(), "month")
                  ) {
                    num += employeeStaticSalary({
                      bene,
                      employee,
                      useExcel,
                      settings,
                      key,
                      totalGross,
                    });
                  }
                });
              } else {
                userLeave.forEach((el) => {
                  if (
                    (moment(el.from, "YYYY-MM-DD").isBefore(
                      moment(),
                      "month"
                    ) ||
                      moment(el.from, "YYYY-MM-DD").isSame(
                        moment(),
                        "month"
                      )) &&
                    (moment(el.to, "YYYY-MM-DD").isAfter(moment(), "month") ||
                      moment(el.to, "YYYY-MM-DD").isSame(moment(), "month"))
                  ) {
                    num += employeeStaticSalary({
                      bene,
                      employee,
                      useExcel,
                      settings,
                      key,
                      totalGross,
                    });
                  }
                });
              }

              total = num;
            }
          } else {
            total = employeeStaticSalary({
              bene,
              employee,
              useExcel,
              settings,
              key,
              totalGross,
            });
          }
        }

        // Tax Law
        if (bene["paymentType"] === "TaxLaw" && bene["enabled"] === true) {
          taxLaw = employeeTaxLaw({
            bene,
            employee,
            useExcel,
            settings,
            key,
            totalGross,
          });
        }
      }

      // Mapping for the Other leves
      if (bene.allSettings?.length > 0) {
        // console.log(bene.slug, "  ====>", bene.level);
        // console.log(pre);
        // console.log(bene.allSettings);
        const childrenValues = bene.allSettings
          .map((e) => pre.find((el) => el?.slug === e?.slug))
          .reduce((a, b) => a + b?.total, 0);

        if (
          bene["DeductType"] === "Employees" &&
          bene["selectedDeducts"]?.includes(employee["userId"])
        ) {
          // sum += childrenValues;
          sum +=
            // settings?.payType !== "Net Pay" && useExcel === "Use Timesheet"
            settings?.payType !== "Net Pay"
              ? (parseFloat(employee?.totalDaysWorked) /
                  parseFloat(settings?.workingDays)) *
                parseFloat(childrenValues)
              : childrenValues;
        } else if (
          bene["DeductType"] === "Job Grade" &&
          bene["selectedDeducts"]?.includes(employee["grade"]?._id)
        ) {
          // sum += childrenValues;
          sum +=
            // settings?.payType !== "Net Pay" && useExcel === "Use Timesheet"
            settings?.payType !== "Net Pay"
              ? (parseFloat(employee?.totalDaysWorked) /
                  parseFloat(settings?.workingDays)) *
                parseFloat(childrenValues)
              : childrenValues;
        } else if (
          bene["DeductType"] === "Contract" &&
          bene["selectedDeducts"]?.includes(employee["contractType"])
        ) {
          // sum += childrenValues;
          sum +=
            // settings?.payType !== "Net Pay" && useExcel === "Use Timesheet"
            settings?.payType !== "Net Pay"
              ? (parseFloat(employee?.totalDaysWorked) /
                  parseFloat(settings?.workingDays)) *
                parseFloat(childrenValues)
              : childrenValues;
        } else if (bene["DeductType"] === "All") {
          // sum += childrenValues;
          sum +=
            // settings?.payType !== "Net Pay" && useExcel === "Use Timesheet"
            settings?.payType !== "Net Pay"
              ? (parseFloat(employee?.totalDaysWorked) /
                  parseFloat(settings?.workingDays)) *
                parseFloat(childrenValues)
              : childrenValues;
        } else if (
          bene["DeductType"] === "Permanent" &&
          employee["usedcontract"] === undefined
        ) {
          sum +=
            // settings?.payType !== "Net Pay" && useExcel === "Use Timesheet"
            settings?.payType !== "Net Pay"
              ? (parseFloat(employee?.totalDaysWorked) /
                  parseFloat(settings?.workingDays)) *
                parseFloat(childrenValues)
              : childrenValues;
        }
      }

      // Calculating total by Percentage
      if (bene["paymentType"] === "Percentage") {
        if (bene["earned"] === true && hours !== undefined) {
          if (
            bene["calculatePer"] === "hour" ||
            bene["calculatePer"] === "day"
          ) {
            total = ((bene.percentage / 100) * sum).toFixed(2);
            total = total * hours;
            totalSum += parseFloat(total);
          } else {
            total = ((bene.percentage / 100) * sum).toFixed(2);
            totalSum += parseFloat(total);
          }
        } else {
          total += ((bene.percentage / 100) * sum).toFixed(2);

          totalSum += parseFloat(total);
        }
      }

      // Calculating total by Static Amount
      if (bene["paymentType"] === "Static" && bene["enabled"] === true) {
        if (bene["earned"] === true && hours !== undefined) {
          if (
            bene["calculatePer"] === "hour" ||
            bene["calculatePer"] === "day"
          ) {
            total = total * hours;
            totalSum = parseFloat(total);
          } else {
            totalSum = parseFloat(total);
          }
        } else {
          totalSum = parseFloat(total);
        }
      }
    }

    return {
      ...bene,
      total: parseFloat(total),
      taxLaw,
    };
  });

  return { totalSum, otherData };
};

export const totalUniqueNum = (
  benefit,
  allowance,
  bonusSettings,
  deductionSettings
) => {
  const beneNums = [
    ...new Set(benefit.map((el) => el.level).sort((a, b) => a - b)),
  ];

  const allowNums = [
    ...new Set(allowance.map((el) => el.level).sort((a, b) => a - b)),
  ];

  const bonNums = [
    ...new Set(bonusSettings.map((el) => el.level).sort((a, b) => a - b)),
  ];

  const dectNums = [
    ...new Set(deductionSettings.map((el) => el.level).sort((a, b) => a - b)),
  ];

  const allNums = [
    ...new Set(
      [...beneNums, ...allowNums, ...bonNums, ...dectNums].sort((a, b) => a - b)
    ),
  ];

  return allNums;
};

export const getGrossPayments = ({ employee, settings, useExcel }) => {
  const totalcustom =
    employee.custom.length > 0
      ? employee.custom.reduce(
          (c, p) => parseFloat(c) + parseFloat(p?.value),
          0
        )
      : 0;

  const housing = employee.housing ? employee.housing : 0;
  const basic = employee.basic ? employee.basic : 0;
  const transport = employee.transport ? employee.transport : 0;
  const medical = employee.medical ? employee.medical : 0;
  const utility = employee.utility ? employee.utility : 0;
  const entertainment = employee.entertainment ? employee.entertainment : 0;
  const dressing = employee.dressing ? employee.dressing : 0;

  const grossPay =
    parseFloat(housing) +
    parseFloat(basic) +
    parseFloat(transport) +
    parseFloat(medical) +
    parseFloat(utility) +
    parseFloat(entertainment) +
    parseFloat(dressing) +
    parseFloat(totalcustom);

  // if (settings?.payType !== "Net Pay" && useExcel === "Use Timesheet") {
  if (settings?.payType !== "Net Pay") {
    employee.dressing =
      (parseFloat(employee?.totalDaysWorked) /
        parseFloat(settings?.workingDays)) *
      parseFloat(dressing);

    employee.entertainment =
      (parseFloat(employee?.totalDaysWorked) /
        parseFloat(settings?.workingDays)) *
      parseFloat(entertainment);

    employee.utility =
      (parseFloat(employee?.totalDaysWorked) /
        parseFloat(settings?.workingDays)) *
      parseFloat(utility);

    employee.medical =
      (parseFloat(employee?.totalDaysWorked) /
        parseFloat(settings?.workingDays)) *
      parseFloat(medical);

    employee.transport =
      (parseFloat(employee?.totalDaysWorked) /
        parseFloat(settings?.workingDays)) *
      parseFloat(transport);

    employee.housing =
      (parseFloat(employee?.totalDaysWorked) /
        parseFloat(settings?.workingDays)) *
      parseFloat(housing);

    employee.basic =
      (parseFloat(employee?.totalDaysWorked) /
        parseFloat(settings?.workingDays)) *
      parseFloat(basic);

    employee.custom =
      employee?.custom?.length > 0
        ? employee?.custom?.map((el) => ({
            ...el,
            value:
              (parseFloat(employee?.totalDaysWorked) /
                parseFloat(settings?.workingDays)) *
              parseFloat(el?.value),
          }))
        : [];
  }

  const ogCustom =
    employee.custom.length > 0
      ? employee.custom.reduce(
          (c, p) => parseFloat(c) + parseFloat(p?.value),
          0
        )
      : 0;

  const ogGrossPay =
    parseFloat(employee.housing ? employee.housing : 0) +
    parseFloat(employee.basic ? employee.basic : 0) +
    parseFloat(employee.transport ? employee.transport : 0) +
    parseFloat(employee.medical ? employee.medical : 0) +
    parseFloat(employee.utility ? employee.utility : 0) +
    parseFloat(employee.entertainment ? employee.entertainment : 0) +
    parseFloat(employee.dressing ? employee.dressing : 0) +
    parseFloat(ogCustom);

  // console.log({
  //   housing: employee.housing,
  //   basic: employee.basic,
  //   transport: employee.transport,
  //   medical: employee.medical,
  //   utility: employee.utility,
  //   entertainment: employee.entertainment,
  //   dressing: employee.dressing,
  //   days: employee?.totalDaysWorked,
  //   total: settings?.workingDays,
  // });

  return { employee, grossPay, ogGrossPay };
};

export const applyTo = [
  { label: "All", value: "All" },
  { label: "Job Grade", value: "Job Grade" },
  { label: "Selected Employees", value: "Employees" },
  { label: "Contract Employees", value: "Contract" },
  { label: "Permanent Employees", value: "Permanent" },
  { label: "Salary Range", value: "Range" },
];

export const maturityPeriod = [
  { label: "Select", value: "" },
  { label: "All Period", value: "All" },
  // { label: "1 month", value: "1 month" },
  // { label: "3 month", value: "3 month" },
  // { label: "6 month", value: "6 month" },
  // { label: "1 year", value: "1 year" },
  { label: "Custom Period", value: "CustomPeriod" },
];

export const duration = [
  { label: "Select", value: "" },
  { label: "Unlimited", value: "All" },
  { label: "Custom Duration", value: "CustomDuration" },
];

export const maturityTime = [
  { label: "Select", value: "" },
  { label: "Month", value: "month" },
  { label: "Year", value: "year" },
];

export const payTypes = [
  { value: "", label: "Choose" },
  { value: "Percentage", label: "Percentage" },
  { value: "Static", label: "Fixed" },
  { value: "TaxLaw", label: "Tax Law Standard" },
];
export const payPer = [
  { value: "", label: "Choose" },
  { value: "hour", label: "Hour" },
  { value: "day", label: "Day" },
  { value: "flatRate", label: "Flat Rate" },
];

export const allBanks = [
  { value: "", label: "Select Payment Bank" },
  { value: "GTBank", label: "GTBank" },
  { value: "Access Bank", label: "Access Bank" },
  { value: "Zenith Bank", label: "Zenith Bank" },
  { value: "First Bank", label: "First Bank" },
];

export const calculateLoan = (employeeLoan, employee) => {
  const {
    paid,
    Amount,
    Term,
    requestid,
    refrenceAccount,
    applyDate,
    payments,
  } = employeeLoan[0];

  const newPaid = parseFloat(paid ? paid : 0) + parseFloat(payments[0]);

  return {
    paid: newPaid,
    balance: parseFloat(Amount) - parseFloat(newPaid),
    Term,
    requestid,
    refrenceAccount,
    applyDate,
    Amount,
    deductAmount: parseFloat(payments[0]),
    payments,
    employeeID: employee.emps_id,
    lastDeductDate: moment(new Date()).format("DD/MM/YYYY"),
  };
};

export const termsValiable = [
  { value: "Monthly", label: "Monthly" },
  { value: "Quaterly", label: "Quaterly" },
  { value: "Bi-Annual", label: "Bi-Annual" },
  { value: "Annual", label: "Annual" },
  { value: "Custom", label: "Custom" },
  { value: "Resume", label: "Resume" },
  { value: "Pause", label: "Pause" },
];

export const converArrayToObject = (array, value, key, isNumber) => {
  return array?.reduce(
    (obj, item) => (
      (obj[item[key]] = isNumber ? parseFloat(item[value]) : item[value]), obj
    ),
    {}
  );
};

export const paginationOptions = {
  previousLabel: <LeftArrowIcon />,
  nextLabel: <RightArrowIcon />,
  pageClassName: "page-item",
  pageLinkClassName: "page-link",
  previousClassName: "page-item",
  previousLinkClassName: "page-link",
  nextClassName: "page-item next",
  nextLinkClassName: "page-link",
  breakLabel: "...",
  breakClassName: "page-item border-none",
  breakLinkClassName: "page-link",
  containerClassName: "pagination",
  activeClassName: "active",
  hrefBuilder: (pageIndex) => {
    let url = new URL(document.location.href);
    let params = new URLSearchParams(url.search);

    params.set("page", pageIndex);
    url.search = params.toString();

    return url.toString();
  },
};

export const scrollToTop = () => {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
};

export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || 500);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}

// export function useQueryParams(
//   defaultParams = {
//     page: 1,
//     limit: 40,
//   }
// ) {
//   function searchParamsToObject(entries) {
//     const result = {};
//     for (const [key, value] of entries) {
//       if (key === "switchCompany") continue;
//       result[key] = value;
//     }

//     return result;
//   }

//   let url = new URL(document.location.href);
//   url = searchParamsToObject(url.searchParams.entries());
//   let requiredQueryParams = defaultParams;

//   const initialQueryParams = !isEmpty(url)
//     ? { ...requiredQueryParams, ...url }
//     : requiredQueryParams;

//   const [searchQuery, setSearchQuery] = useSearchParams(initialQueryParams);
//   const [queryParams, setQueryParams] = useState(initialQueryParams);
//   const debouncedQueryParams = useDebounce(queryParams, 500);

//   useEffect(() => {
//     setSearchQuery(debouncedQueryParams, { replace: true });
//   }, [debouncedQueryParams]);

//   return [queryParams, setQueryParams];
// }

export function useScrollTop() {
  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    // document.documentElement.scrollTop = 0;
    console.log("scroll top");
  }, []);

  return null;
}

export const calculateAttendance = ({
  attendance,
  employee,
  attendanceSetting,
  grossPay,
  netPay,
}) => {
  let data = {};
  let total = 0;
  const employeeAttendance = attendance.filter(
    (el) => el?.ID === employee?.employeeId
  );

  if (employeeAttendance.length > 0) {
    let NoSignOut = employeeAttendance.filter(
      (el) => el?.result === "No SignOut"
    );
    let Late = employeeAttendance.filter((el) => el?.result === "Late");
    let EarlyClosure = employeeAttendance.filter(
      (el) => el?.result === "Early Closure"
    );
    let Absent = employeeAttendance.filter((el) => el?.result === "Absent");

    if (attendanceSetting.deductType === "Gross Pay") {
      NoSignOut =
        (parseFloat(attendanceSetting.NoSignOut) / 100) *
        parseFloat(grossPay) *
        parseFloat(NoSignOut.length);
      Late =
        (parseFloat(attendanceSetting.Lateness) / 100) *
        parseFloat(grossPay) *
        parseFloat(Late.length);
      EarlyClosure =
        (parseFloat(attendanceSetting.EarlyClosure) / 100) *
        parseFloat(grossPay) *
        parseFloat(EarlyClosure.length);
      Absent =
        (parseFloat(attendanceSetting.Absent) / 100) *
        parseFloat(grossPay) *
        parseFloat(Absent.length);
    } else if (attendanceSetting.deductType === "Net Pay") {
      NoSignOut =
        (parseFloat(attendanceSetting.NoSignOut) / 100) *
        parseFloat(netPay) *
        parseFloat(NoSignOut.length);
      Late =
        (parseFloat(attendanceSetting.Lateness) / 100) *
        parseFloat(netPay) *
        parseFloat(Late.length);
      EarlyClosure =
        (parseFloat(attendanceSetting.EarlyClosure) / 100) *
        parseFloat(netPay) *
        parseFloat(EarlyClosure.length);
      Absent =
        (parseFloat(attendanceSetting.Absent) / 100) *
        parseFloat(netPay) *
        parseFloat(Absent.length);
    } else {
      NoSignOut = 0;
      Late = 0;
      EarlyClosure = 0;
      Absent = 0;
    }

    data = {
      NoSignOut,
      Late,
      EarlyClosure,
      Absent,
    };
    total = NoSignOut + Late + EarlyClosure + Absent;
  }

  return { data, total };
};

export function calculateTax({ income, amount, percent, rateAmount }) {
  if (income - amount < 0) {
    return 0;
  } else if (income - amount < rateAmount) {
    return percent * (income - amount);
  } else {
    return percent * rateAmount;
  }
}

export function calculateSingleTax({ income, amount, percent }) {
  if (income < amount) {
    return percent * income;
  } else {
    return percent * amount;
  }
}

export function taxComputation({ computation, chargeableIncome }) {
  const taxRateArray = [];
  let taxRateAsPerMonthlyTotal = 0;

  for (let index = 0; index < computation?.length; index++) {
    const element = computation[index];

    if (element?.rateAmount && element?.ratePercentage) {
      if (index === 0) {
        const amount = calculateSingleTax({
          income: chargeableIncome,
          amount: element?.rateAmount,
          percent: element?.ratePercentage / 100,
        });

        const data = {
          percent: element?.ratePercentage,
          amount: toNumber(amount.toFixed(2)),
        };

        taxRateArray.push(data);
      } else {
        const oldOnes = computation.slice(0, index);
        const totalAmount = oldOnes?.reduce((c, p) => c + p.rateAmount, 0);

        const amount = calculateTax({
          income: chargeableIncome,
          amount: totalAmount,
          percent: element?.ratePercentage / 100,
          rateAmount: element?.rateAmount,
        });

        const data = {
          percent: element?.ratePercentage,
          amount: toNumber(amount.toFixed(2)),
        };

        taxRateArray.push(data);
      }
    }
  }

  taxRateAsPerMonthlyTotal = toNumber(
    taxRateArray?.reduce((c, p) => c + p.amount, 0).toFixed(2)
  );

  return {
    taxRateAsPerMonthlyTotal:
      taxRateAsPerMonthlyTotal > 513.34 ? taxRateAsPerMonthlyTotal : 0,
    taxRateArray,
  };
}

export function calculateInvexRetainment({ retaire, netPay }) {
  let remainingRetairment = 0;
  let retairefee = 0;

  if (retaire && retaire?.Amount > 0) {
    retairefee = retaire.Amount;
    if (parseFloat(netPay) > parseFloat(retairefee)) {
      remainingRetairment = parseFloat(retairefee);
    } else {
      remainingRetairment = parseFloat(netPay);
    }
  }

  return { remainingRetairment, retairefee };
}

// ------------------------------NEW LOGO ------------------------------
export function NewLogo(props) {
  return (
    <svg
      {...props}
      style={{ ...props.style, maxWidth: "8rem", height: "fit-content" }}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="1872"
      height="557"
      viewBox="0 0 1872 557"
    >
      <LogoImage />
    </svg>
  );
}

export function dateWithNowTime(
  salesDate = new Date(),
  dateFormat = "yyyy-MM-dd"
) {
  if (salesDate) {
    return (
      moment(new Date(salesDate)).format(dateFormat) +
      moment(new Date()).format(" HH:mm:ss.SSS")
    );
  } else {
    moment(new Date()).format("yyyy-MM-dd HH:mm:ss.SSS");
  }
}

export function searchParamsToObject(entries) {
  const result = {};
  for (const [key, value] of entries) {
    if (key === "switchCompany") continue;
    result[key] = value;
  }

  return result;
}

export function getQueryParams() {
  let url = new URL(document.location.href);
  url = url.searchParams.entries();
  const result = {};
  for (const [key, value] of url) {
    result[key] = value;
  }

  return result;
}

export function calculateWorkDays({ date, payrollDate, current, workedDays }) {
  const workDate = moment(date, "DD/MM/YYYY");

  let curr;
  if (workedDays) {
    const startMonth = moment(
      `1/${payrollDate.payrollMonth}/${payrollDate.payrollYear}`,
      "DD/MM/YYYY"
    ).startOf("month");

    curr = workDate.diff(startMonth, "days");
  } else {
    const endMonth = moment(
      `1/${payrollDate.payrollMonth}/${payrollDate.payrollYear}`,
      "DD/MM/YYYY"
    ).endOf("month");

    curr = endMonth.diff(workDate, "days");
    curr = curr + 1;
  }

  if (curr < current && Math.sign(curr) !== -1) {
    current = curr;
  }

  return current;
}

export const sendFormData = async ({ url, formData, token }) => {
  const headers = token
    ? {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,
        },
        body: formData,
      }
    : {
        method: "POST",
        body: formData,
      };
  let response = await fetch(url, { ...headers });

  if (!response.ok) {
    response = await response.json();

    throw new Error(response.message);
  }

  const data = await response.json();
  return data;
};

export const filterNonPaidEmployees = ({
  filterData,
  payrollDate,
  Employees,
}) => {
  const terminates = filterData
    ?.map((ter) => ({
      after: checkAfterDate({
        date: ter.date,
        payrollDate,
      }),
      employeeId: ter.employeeId,
      date: ter.date,
    }))
    .filter((el) => el.after === false);

  const normalEmployees = Employees?.filter((employee) => {
    if (
      terminates?.find((terminate) => terminate.employeeId === employee.userId)
    ) {
      return false;
    } else {
      return true;
    }
  });

  return normalEmployees;
};

export function copyText({ text, successText = "Copied" }) {
  const textarea = document.createElement("textarea");
  textarea.textContent = text;
  textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
  document.body.appendChild(textarea);
  textarea.select();
  textarea.setSelectionRange(0, 99999);
  document.execCommand("copy");
  document.body.removeChild(textarea);
  toast.success(successText);
}

export const getDomainOrigin = () => {
  const url = new URL(window.location.href);
  return url.origin;
};

export function calculateTimeDifference({ day, month, year }) {
  // Today's date
  const today = new Date();

  // The given date (day/month/year)
  const givenDate = new Date(year, month - 1, day); // months are 0-indexed

  // Calculate difference in days
  const timeDiff = today - givenDate;
  const daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24)); // Convert milliseconds to days

  // Calculate difference in months
  let monthsDiff = (today.getFullYear() - givenDate.getFullYear()) * 12;
  monthsDiff += today.getMonth() - givenDate.getMonth();
  if (today.getDate() < givenDate.getDate()) {
    monthsDiff--;
  }

  // Calculate difference in years
  let yearsDiff = today.getFullYear() - givenDate.getFullYear();
  if (
    today.getMonth() < givenDate.getMonth() ||
    (today.getMonth() === givenDate.getMonth() &&
      today.getDate() < givenDate.getDate())
  ) {
    yearsDiff--;
  }

  // Determine the most appropriate unit
  let result = "";
  if (yearsDiff > 0) {
    result = `${yearsDiff} year${yearsDiff > 1 ? "s" : ""} ago`; // Singular or plural years
  } else if (monthsDiff > 0) {
    result = `${monthsDiff} month${monthsDiff > 1 ? "s" : ""} ago`; // Singular or plural months
  } else {
    result = `${daysDiff} day${daysDiff > 1 ? "s" : ""} ago`; // Singular or plural days
  }

  return result;
}

export const changeDateFormat = (date) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  date = date.split("/");
  return months[parseInt(date[1]) - 1] + " " + date[0] + ", " + date[2];
};

export const stringifyQueryString = (queryObject) => {
  const params = new URLSearchParams();

  Object.keys(queryObject).forEach((key) => {
    const value = queryObject[key];
    if (Array.isArray(value)) {
      value.forEach((val) => params.append(key, val));
    } else {
      params.set(key, value);
    }
  });

  return params.toString();
};

export const chooseAttendanceStatusColor = (status) => {
  let result = {
    "No SignOut": "red-action",
    "Early Closure": "red-action",
    Late: "red-action",
    Absent: "red-action",
    Good: "green-action",
    OnLeave: "orange-action",
    Permitted: "blue-action",
    "Not a staff": "blue-action",
  };

  // Default colors if status doesn't match
  return result[status] || "blue-action";
};

export const statusColor = (status) => {
  let result = {
    red: "red-action",
    green: "green-action",
    orange: "orange-action",
    blue: "blue-action",
  };

  // Default colors if status doesn't match
  return result[status] || "blue-action";
};

export const arrangeEventObject = ({ name, value }) => {
  return {
    target: {
      name,
      value,
    },
  };
};

// let url = new URL(document.location.href);
// url = searchParamsToObject(url.searchParams.entries());
